<div class="container-fluid mt-1 ">
  <nav class="navbar navbar-expand-lg bg-white shadow-sm  rounded-pill  px-4 py-3">
    <a class="navbar-brand" (click)="home()">
      <img src="../../assets/images/login-logo(crop).png" alt="Logo" class="logo" style="cursor: pointer;">
    </a>

    <button class="navbar-toggler" type="button" (click)="toggleOffCanvas()">
      <span class="navbar-toggler-icon"></span>
    </button>

    <div class="collapse navbar-collapse justify-content-end" id="navbarNav">
      <ul class="navbar-nav align-items-center gap-2 bg-light rounded-pill px-3">
        <li class="nav-item">
          <img src="../../assets/images/map (1).png" class="dollar-logo me-2" alt="Map">
        </li>
        <li class="nav-item">
          <a class="nav-link map-view-link" (click)="mapView()" style="cursor: pointer;">Map View</a>
        </li>
        <li class="nav-item">
          <a class="nav-link" href="javascript:void(0)" (click)="properties()">All Properties</a>
        </li>
        <li class="nav-item">
          <a class="nav-link" href="javascript:void(0)" (click)="scrollToSection('featured')">Featured Properties</a>
        </li>
      </ul>

      <ul *ngIf="!checkLoginStatus" class="navbar-nav ms-3 bg-light px-3 rounded-pill border border-dark">
        <li class="nav-item">
          <a class="nav-link contact" (click)="logIn()" style="cursor: pointer;">Login</a>
        </li>
      </ul>

      <div *ngIf="checkLoginStatus" class="profile-container d-flex align-items-center ms-3">
        <fa-icon [icon]="userCircleIcon" class="profile-dropdown-menu"
          style="color:#fbb416; font-size: 40px; cursor: pointer;" (click)="toggleMenu()"></fa-icon>
        <div *ngIf="menuVisible" class="profile-menu">
          <a (click)="profile()">Profile</a>
          <a (click)="logOut()">Logout</a>
        </div>
      </div>
    </div>
  </nav>
</div>

<!-- Overlay -->
<div class="overlay" *ngIf="isOffCanvasOpen" (click)="toggleOffCanvas()"></div>

<!-- Off-canvas -->
<div class="offcanvas-custom" [ngClass]="{'show': isOffCanvasOpen}">
  <div class="offcanvas-container">
    <div class="d-flex justify-content-between align-items-center mb-3">
      <a class="navbar-brand" (click)="home()">
        <img src="../../assets/images/Property box logo with out back ground (1).png" alt="Logo" class="logo">
      </a>
      <img src="../../../assets/images/icons8-cancel.svg" alt="Close" class="close-icon" (click)="toggleOffCanvas()">
    </div>
    <ul class="list-unstyled">
      <li (click)="mapView(); toggleOffCanvas()">Map View</li>
      <li (click)="properties(); toggleOffCanvas()">All Properties</li>
      <li (click)="scrollToSection('featured'); toggleOffCanvas()">Featured Properties</li>
      <li *ngIf="!checkLoginStatus" (click)="logIn(); toggleOffCanvas()">Login</li>
      <li *ngIf="checkLoginStatus" (click)="profile(); toggleOffCanvas()">Profile</li>
      <li *ngIf="checkLoginStatus" (click)="logOut(); toggleOffCanvas()">Logout</li>
    </ul>
  </div>
</div>
